import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import RADLOGO from "../images/RADLOGO.jpeg";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="solar-footer">
      <div className="container">
        <div className="row g-5">

          {/* BRAND */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand">
              <img src={RADLOGO} alt="RAD EnviroNex Logo" />
              <h4>RAD ENVIRONEX</h4>
              <p>
                Delivering sustainable solar and environmental solutions.
                "Nature inspired solution".
              </p>
              <div className="footer-contact-info mt-3">
                <p><i className="fa fa-phone me-2"></i> <a href="tel:+919597839564" style={{ color: 'inherit', textDecoration: 'none' }}>+91 95978 39564</a></p>
                <p><i className="fa fa-envelope me-2"></i> <a href="mailto:info@radenvironex.com" style={{ color: 'inherit', textDecoration: 'none' }}>info@radenvironex.com</a></p>
                <p><i className="fa fa-map-marker-alt me-2"></i> Madurai, Tamil Nadu, India</p>
              </div>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-2 col-md-6">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/About">About</Link></li>
              <li><Link to="/Services">Services</Link></li>
              {/* <li><Link to="/Gallery">Gallery</Link></li> */}
              <li><Link to="/Contact">Contact</Link></li>
            </ul>
          </div>

          {/* LEGAL */}
          <div className="col-lg-2 col-md-6">
            <h5 className="footer-title">Legal</h5>
            <ul className="footer-links">
              <li><Link to="/Privacy">Privacy Policy</Link></li>
              <li><Link to="/Terms">Terms & Conditions</Link></li>
            </ul>
          </div>

          {/* SOCIAL */}
          <div className="col-lg-4 col-md-6">
            <h5 className="footer-title">Connect With Us</h5>

            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61588615206940" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://www.instagram.com/rad_environex/" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.linkedin.com/in/radenvironex-raj-venkatesh-43353b3b6/" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="https://www.youtube.com/channel/UC_JYzk0J8A84DuOOYXySM0w" aria-label="YouTube"><FaYoutube /></a>
              <a
                href="https://wa.me/919597839564"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>

            <p className="footer-note">
              <p className="footer-serving-text">
                Proudly serving diverse industries with sustainable solutions across the world.
              </p>
            </p>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} RAD EnviroNex. All Rights Reserved.
          </p>

          <p className="footer-credit">
            Built to inspire by{" "}
            <a
              href="https://www.semmssolutions.com/"
              target="_blank"
              rel="noreferrer"
            >
              SEMMS Solution – Elevating Your Digital Journey!
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
